<template>
  <div>
      <b-row>
    <b-col md="12">
      <b-card>
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="4">
                <span class="pr-"><strong>총 {{items.length}}건</strong></span>
              </b-col>
              <b-col sm="3"></b-col>
              <b-col sm="3"></b-col>
              <b-col md="2" class="my-1">
                <b-row>
                  <b-col sm="6">
                    <b-form-select v-model="perPage" :options="pageOptions"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>

          <b-col sm="12" class="pt-sm-1">
            <b-row>
              <b-col sm="12">
                <b-table striped hover :fields="fieldItems" :items="items" :busy="items == 0" :current-page="currentPage" :per-page="perPage">
                  <div slot="table-busy" class="text-center my-2">
                    <strong>데이터가 없습니다.</strong>
                  </div>
                </b-table>
              </b-col>
            </b-row>
          </b-col>

          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="12" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="items.length" :per-page="perPage" align="center"/>
              </b-col>
            </b-row>
          </b-col>

        </b-row>



      </b-card>
    </b-col>
  </b-row>
  </div>
</template>
<script>


import DatePicker from 'vue2-datepicker';

export default {
  name:'LoginLogManagement',
  components: {
    
    DatePicker,
  },
  data() {
    return {
      fullDate: [],
      items: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30, 50, 100],
      queryParams: {
        start_date: '',
        end_date: '',
        keyword: '',
      },
      fieldItems: [{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'manager_id': {
          'label': '관리자 아이디',
          'class': 'text-center',
          'thStyle': {'vertical-align': 'middle'}
        }
      }, {
        'login_date': {
          'label': '로그인 일자',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle',
            'text-align': 'center'
          }
        }
      }],
    }
  },
  computed: {
    listRows() {
      return this.items.length
    }
  },
  mounted: function() {
    this.findLoginLogList();
  },
  methods: {

    findLoginLogList() {
      var self = this;
      var token = sessionStorage.getItem("myToken");

      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('objs', param);

      self.$http.post('/api/select/managerLoginLogList?access_token=' + token, data, null)
        .then((result) => {
          self.items = result.data;
          var itemCnt = self.items.length;
          self.items.forEach(function (el, idx, arr){
            el.rnum = itemCnt - (idx);
            el.selectchecked = false;

          });
        })
    },

  }
}

</script>




// WEBPACK FOOTER //
// src/views/common/LoginLogManagement.vue